document.addEventListener( 'click', function ( event ) {
	var inner = event.target.closest( '.mcs-card__inner' );

	if ( ! inner ) {
		return;
	}

	if ( window.matchMedia( '(hover: hover)' ).matches ) {
		return;
	}

	var panel = inner.querySelector( '.mcs-card__panel' );

	if ( ! panel ) {
		return;
	}

	if ( inner.classList.contains( 'is-open' ) ) {
		return;
	}

	event.preventDefault();

	var grid = inner.closest( '.magrino-client-showcase' );

	if ( grid ) {
		grid.querySelectorAll( '.mcs-card__inner.is-open' ).forEach( function ( open ) {
			open.classList.remove( 'is-open' );
		} );
	}

	inner.classList.add( 'is-open' );
} );
